import PropTypes from 'prop-types';
import EmailRecipient from './email-recepient';

const EmailRecipients = ({ recipients = [] }) => {
  return (
    <div className="outreach-card-recipient-name">
      {recipients?.length ? (
        recipients.map((recipient, i) => (
          <div key={recipient.id}>
            <EmailRecipient recipient={recipient} />
            {i < recipients.length - 1 && ', '}
          </div>
        ))
      ) : (
        <div className="outreach-card-recipient-name-empty">--</div>
      )}
    </div>
  );
};

EmailRecipients.propTypes = {
  recipients: PropTypes.array,
};

export default EmailRecipients;
